import React, {Component} from 'react'

import Suppliers from './Smartphones'
import IpadNavigation from 'Navigation/IpadNavigation'

export default class SuppliersView extends Component {
  render () {
    return (
      <IpadNavigation {...this.props} onlyLeftSide setCurrentLink>
        <Suppliers {...this.props} />
      </IpadNavigation>
    )
  }
}
